import { max, nonNullable } from 'lib/array/arrayUtils'

function getOrderAccommodationEndDate(order: App.Order): string | undefined {
  return max(nonNullable(order.items.map(item => item.reservation?.endDate)))
}

export default getOrderAccommodationEndDate
